/* eslint-disable require-jsdoc */
import {S3Client, PutObjectCommand, GetObjectCommand} from '@aws-sdk/client-s3';
import {getSignedUrl} from '@aws-sdk/s3-request-presigner';
import {fromCognitoIdentityPool} from '@aws-sdk/credential-providers';
import {awsConfigs} from '@/constant/env.js';
import {Buffer} from 'buffer';

const client = new S3Client({
  region: awsConfigs.region,
  credentials: fromCognitoIdentityPool({
    clientConfig: {region: awsConfigs.region},
    identityPoolId: awsConfigs.identityPoolId,
  }),
});

const getObjectUrl = async (Key) => {
  const command = new GetObjectCommand({
    Bucket: awsConfigs.privateBucket,
    Key,
  });
  const url = await getSignedUrl(client, command, {expiresIn: 60});
  return url;
};

const putObject = async ({key, arrayBuffer}) => {
  const Body = Buffer.from(arrayBuffer);
  const command = new PutObjectCommand({
    Bucket: awsConfigs.privateBucket,
    Key: key,
    Body,
  });
  return client.send(command);
};

export {getObjectUrl, putObject};
